module.exports = __webpack_public_path__ + "static/media/New_Jersey_Devils.db4cfde2.svg";